"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTotalJackpot = void 0;
var swr_hooks_1 = require("@l2p/swr-hooks");
var useTotalJackpot = function () {
    var data = (0, swr_hooks_1.useTotalJackpotsFlexInterval)().data;
    return data;
};
exports.useTotalJackpot = useTotalJackpot;
